import React from "react";

export default function PaymentLoading() {
  return (
    <div className="bg-[#141414] border border-gray-800 p-8 px-6 md:px-20 min-h-[18rem] rounded-2xl flex justify-center items-center flex-col md:mx-auto text-white shadow-2xl max-w-md w-full">
      <div className="w-16 h-16 border-4 border-gray-800 border-t-secondary rounded-full animate-spin mb-6"></div>

      <div className="text-center">
        <h3 className="md:text-2xl text-xl text-white font-bold text-center mb-2">
          Transaction in progress
        </h3>
        <p className="text-gray-400 my-2 text-sm md:text-base">
          Please don't close this window
        </p>
      </div>
    </div>
  );
}
